import IconButton from '@/shared/components/IconButton/IconButton'
import { Autocomplete, Box, ClickAwayListener, TextField } from '@mui/material'
import { useState } from 'react'
import { ShapeType } from '@/shared/api/BaseAPI.model'
import { listboxStyles, listElementStyles, popperStyles } from './Select.styles'
import styles from './Select.module.scss'

interface HandleIconClickEvent {
  currentTarget: HTMLElement
}

interface ShapeSelectProps {
  onChange: (value: ShapeType) => void
  value: string
}

const shapeOptions = [
  {
    label: 'Horizontal rectangle',
    value: 'horizontalRectangle',
    icon: <div className={styles.horizontalRectangleShapeIcon} />
  },
  {
    label: 'Vertical rectangle',
    value: 'verticalRectangle',
    icon: <div className={styles.verticalRectangleShapeIcon} />
  },
  {
    label: 'Circle',
    value: 'circle',
    icon: <div className={styles.circleShapeIcon} />
  },
  {
    label: 'Square',
    value: 'square',
    icon: <div className={styles.squareShapeIcon} />
  }
]

function ShapeSelect(props: ShapeSelectProps) {
  const { onChange, value } = props
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleIconClick = (event: HandleIconClickEvent) => {
    setAnchorEl(event.currentTarget)
    setOpen(prev => !prev)
  }

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Box display="flex" alignItems="center">
        <Autocomplete
          id="color-format-select"
          open={open}
          value={shapeOptions.find(option => option.value === value)}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          defaultValue={shapeOptions[0]}
          options={shapeOptions}
          onChange={(_, newValue) => {
            if (onChange) {
              onChange(newValue?.value as ShapeType)
            }
            setOpen(false)
          }}
          disableClearable
          popupIcon={null}
          renderInput={params => (
            <TextField {...params} sx={{ display: 'none' }} />
          )}
          slotProps={{
            paper: {
              sx: popperStyles
            },
            listbox: {
              sx: listboxStyles
            },
            popper: {
              sx: { ...popperStyles, width: 'auto !important', zIndex: 9999 },
              anchorEl,
              placement: 'bottom-start',
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, 8]
                  }
                }
              ]
            }
          }}
          renderOption={(props, option) => (
            <Box
              component="li"
              {...props}
              sx={{
                ...listElementStyles,
                '&.MuiAutocomplete-option': {
                  paddingLeft: '8px'
                }
              }}
            >
              <div className={styles.optionWrapper}>
                {value === option.value && (
                  <i
                    className={`las la-check icon-small ${styles.optionCheckIcon}`}
                  />
                )}
                {option.icon}
                {option.label}
              </div>
            </Box>
          )}
        />
        <div className={styles.shapeSelectButtonWrapper}>
          <div className={styles.selectedShapeIconWrapper}>
            {shapeOptions.find(option => option.value === value)?.icon}
          </div>
          <IconButton
            icon={<i className="las la-angle-down icon-small" />}
            color="primary"
            onClick={handleIconClick}
          />
        </div>
      </Box>
    </ClickAwayListener>
  )
}

export default ShapeSelect
